import Sidebar from "../components/Sidebar";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";

export default function DefaultLayout({
                                        icon,
                                        title,
                                        subtitle,
                                        headerContent,
                                        children
}) {
  return (
    <div id="layoutSidenav">
      <div id="layoutSidenav_nav">
        <Sidebar/>
      </div>
      <div id="layoutSidenav_content">
        <main>
          {title && <PageHeader icon={icon}
                                title={title}
                                subtitle={subtitle}
                                content={headerContent}/>}
          {children}
        </main>
        {/*<Footer/>*/}
      </div>
    </div>
  );
}
